module.exports = __webpack_public_path__ + "static/scale-model-of-tree-hill-nature-center-in-jacksonville-florida-c630359ece03866e90362541ed0d11dd.png";